import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {getGoogleSheet, getMethodTypeStocks, getMyPrediction, getSymbolList} from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import { useNavigate } from "react-router-dom";
import { AIPromptForStock1, diffDays } from "../utils/constants";
import SectorPanchang from "../component/sectorPanchag";
import StockStrength from "../component/stockStrength";

const GoldenStocksPage = () => {
  const [loader, setLoader] = useState(false);
  const [symbolData, setSymbolData] = useState([]);
  const [todayData, setTodayData] = useState([]);
  const [todayDate, setTodayDate] = useState([]);
  const NSE_Past_date = useSelector((state) => state.pastDate.value);
  // const [startDate, setStartDate] = useState(NSE_Past_date[0]?.max_date);
  const [series, setSeries] = useState('EQ');
  const [startDate, setStartDate] = useState(new Date());
  const [predictionData, setPredictionData] = useState([]);
  const [getGoldenStocks, setGoldenStocks] = useState([]);
  const [getMethodTypeData, setMethodTypeData] = useState([]);
  const userToken = useSelector((state) => state.userToken.value);
  const navigate = useNavigate();
  const deliveryDataList = useSelector((state) => state.deliveryData.value);

  useEffect(() => {
    if (userToken) {
      let current_date = moment(startDate).format("DDMMYY");

      let paylaod = {
        date: "All",
        series: "EQ",
        method: "Golden Breakout",
      };
      getMethodTypeStocks(paylaod, userToken)
        .then(function (response) {
          setMethodTypeData(response.data.data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });

      getSymbolList(series, '', userToken)
        .then(function (response) {
          setSymbolData(response.data.data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });

      getMyPrediction(current_date, userToken)
        .then(function (response) {
          setPredictionData(response.data.data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });

      getGoogleSheet("", userToken)
        .then(function (response) {
          setTodayData(response.data.data.json_data);
          setTodayDate(response.data.data.datetime);
        })
        .catch(function (err) {
          console.log("Error", err);
        });
    } else {
      navigate(`/`);
    }
  }, [startDate]);

  useEffect(() => {
    setLoader(false);

    if (getMethodTypeData && todayData && symbolData && predictionData) {
      const currentFilteredData = getMethodTypeData
        ?.filter((item) => {
          const match = symbolData.find(
            (s) =>
              s.symbol === item.symbol && s.active === "1" && s.series === "EQ"
          );

          return match;
        })
        .map((item) => {
          const match = symbolData.find((s) => s.symbol === item.symbol);
          const prediction = predictionData.find(
            (p) => p.symbol === item.symbol
          );
          return {
            ...item,
            details: match,
            prediction: prediction,
          };
        });
      // console.log(currentFilteredData);
      setGoldenStocks(currentFilteredData);
      setLoader(true);
    }
  }, [deliveryDataList, predictionData, symbolData]);

  let totalPL = 0;

  return (
    <React.Fragment>
      <div className="pageContainer">
        {loader === false ? (
          <PageLoader />
        ) : (
          <div className="pagewrap fullheight">
            <table className="increaseOI table-responsive">
              <thead>
                <tr key="item_0_0">
                  <th style={{ width: "120px" }}>Date</th>
                  <th style={{ width: "18px" }}>Days</th>
                  <th style={{ width: "120px", textAlign: "left" }}>
                    Symbol [{getGoldenStocks?.length}]
                  </th>
                  <th style={{ width: "15px" }}></th>
                  <th style={{ width: "40px" }}></th>
                  <th style={{ width: "40px", textAlign: "left" }}>Strength</th>
                  <th style={{ width: "110px", textAlign: "left" }}>Sector</th>
                  <th style={{ width: "55px", textAlign: "left" }}>Indices</th>
                  <th style={{ width: "55px", textAlign: "left" }}>Trends</th>
                  <th style={{ width: "70px" }}>Break Price</th>
                  <th style={{ width: "50px" }}>B Chn%</th>
                  <th style={{ width: "60px" }}>LTP</th>
                  <th style={{ width: "50px" }}>Chn%</th>
                  <th style={{ width: "50px" }}>T Chn%</th>
                  <th style={{ width: "50px" }}>14 Days</th>
                  <th style={{ width: "50px" }}>DMA50</th>
                  <th style={{ width: "50px" }}>DMA200</th>
                  {/* <th style={{width:'150px'}}>14 | 9 | 5 Deg&deg;</th>
                            <th style={{width:'45px'}}>RSI</th>
                            <th style={{width:'45px'}}>ADX</th> */}
                  <th style={{ width: "60px" }}>52 Down</th>
                  <th style={{ width: "115px" }}>52 L/H</th>
                  <th style={{ width: "75px" }}>AT Vol</th>
                  {/* <th style={{width:'120px'}}>Curr Vol</th> */}
                  <th style={{ width: "50px" }}>Del%</th>
                  <th style={{ width: "25px" }}>News</th>
                </tr>
              </thead>
              <tbody>
                {getGoldenStocks?.map((item, index) => {
                  let symbolName = item.symbol;
                  let todayLTP = todayData?.find(
                    (item, index) => item.TICKER === symbolName
                  );
                  // let angle_5 = degAngle(item.prediction?.price_5, todayLTP?.LTP, 5);
                  // let angle_9 = degAngle(item.prediction?.price_9, todayLTP?.LTP, 9);
                  // let angle_14 = degAngle(item.prediction?.price_14, todayLTP?.LTP, 14);
                  let prevVolume = (
                    ((parseInt(todayLTP?.VOLUME) -
                      parseInt(item.prediction?.ttl_trd_qty)) *
                      100) /
                    parseInt(item.prediction?.ttl_trd_qty)
                  ).toFixed(2);
                  totalPL =
                    totalPL +
                    ((todayLTP?.LTP - item.breakout_price) * 100) /
                      item.breakout_price;

                  return (
                    <tr
                      className={`tr_${item.details?.id}`}
                      key={`row_item_${index}`}
                      id={`row_item_${index}`}
                    >
                      <td style={{ textAlign: "left" }}>
                        {moment(item.datetime).format("DD-MM-YY HH:mm A")}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {diffDays(item.datetime, new Date())}
                      </td>
                      <td
                        className="symbolName"
                        style={{
                          textAlign: "left",
                          lineHeight: 1.1,
                          background:
                            parseFloat(item.prediction?.delivery_per) > 40 &&
                            item.prediction?.sma_angle_5 > 1 &&
                            todayLTP?.VOLUME > item.prediction?.ttl_trd_qty
                              ? "#cde9d7"
                              : null,
                        }}
                      >
                        {symbolName}
                        {item.symbol_count > 1 ? `[${item.symbol_count}]` : ""}
                        {/* {moment(new Date()).isSame(moment(item.breakout_date), 'day') ? (item.occurance > 1 ? `(${item.occurance})` : item.symbol_count > 1 ? `(${item.symbol_count})` : '') : ''} */}
                        {item.details.hotStar === "1" ? (
                          <span className="hotStar"></span>
                        ) : null}
                      </td>
                      <td>
                        <StockAction
                          symbol={symbolName}
                          delivery={false}
                          currentPrice={todayLTP?.LTP}
                          deliveryPer={item.prediction?.delivery_per}
                          hotStar={item.details.hotStar}
                          myFev={item.details.myFev}
                          eventName="Golden Stocks"
                          rowId={`row_item_${index}`}
                        />
                      </td>
                      <td style={{ textAlign: "left" }}>
                        <DeliveryGraph
                          symbol={symbolName}
                          todayLTP={todayLTP}
                          date={moment(NSE_Past_date[0]?.max_date).format(
                            "YYYY-MM-DD"
                          )}
                        />
                      </td>
                      <StockStrength
                        id={`gs_${index}`}
                        selectedDate={startDate}
                        symbol={symbolName}
                        todayLTP={todayLTP}
                        details={item.details}
                        predictions={item.prediction}
                      />
                      <SectorPanchang
                        symbol={symbolName}
                        sector={item.details?.group_sector}
                        todayData={todayData}
                        symbolData={symbolData}
                        tag = "td"
                        align = "right"
                        durationDays = ""
                      />
                      <td className="indices" style={{ textAlign: "left" }}>
                        {(() => {
                          const label = item.details.nifty50
                            ? "50"
                            : item.details.nifty100
                            ? "100"
                            : item.details.nifty200
                            ? "200"
                            : item.details.nifty500
                            ? "500"
                            : item.details.totalMarket
                            ? "TM"
                            : "";
                          const excludedSeries = ["ETF", "BOND", "MF"];
                          const showFev =
                            item.details.myFev &&
                            !excludedSeries.includes(item.details.series);
                          return (
                            label + (showFev ? `${label ? ", " : ""}Fev` : "")
                          );
                        })()}
                      </td>
                      <td style={{ textAlign: "left" }}></td>
                      <td>{item.breakout_price}</td>
                      <td
                        style={{
                          color:
                            parseFloat(item?.chn_per) > 0 ? "#1c8b16" : "#f00",
                        }}
                      >
                        {parseFloat(item.chn_per)}%
                      </td>
                      <td>{parseFloat(todayLTP?.LTP).toFixed(2)}</td>
                      <td
                        style={{
                          color: todayLTP?.CHANGEPER > 0 ? "#1c8b16" : "#f00",
                        }}
                      >
                        {todayLTP?.CHANGEPER.toFixed(2)}%
                      </td>
                      <td
                        style={{
                          color:
                            ((todayLTP?.LTP - item.breakout_price) * 100) /
                              item.breakout_price >
                            0
                              ? "#1c8b16"
                              : "#f00",
                        }}
                      >
                        {(
                          ((todayLTP?.LTP - item.breakout_price) * 100) /
                          item.breakout_price
                        ).toFixed(2)}
                        %
                      </td>

                      <td>
                        {parseFloat(item.prediction?.price_14_date_PL).toFixed(
                          2
                        )}
                        %
                      </td>
                      <td
                        style={{
                          background:
                            parseFloat(item.prediction?.sma20) <
                            parseFloat(item.prediction?.sma50)
                              ? "#fce5e5"
                              : "",
                        }}
                        title={`DMA20: ${item.prediction?.sma20}`}
                      >
                        {item.prediction?.sma50}
                      </td>
                      <td
                        style={{
                          background:
                            parseFloat(item.prediction?.sma50) >
                            parseFloat(item.prediction?.sma200)
                              ? "#e2ffe5"
                              : "#fff8f8",
                        }}
                        title={`DMA50: ${item.prediction?.sma50}`}
                      >
                        {item.prediction?.sma200}
                      </td>

                      {/* <td style={{textAlign:'right', backgroundColor: (parseFloat(angle_5) > parseFloat(angle_9)) && (parseFloat(angle_9) > parseFloat(angle_14))? '#e9ffe3':''}}>
                                    {angle_14}&deg; | {angle_9}&deg; | {angle_5}&deg;
                                </td>
                                <td>{parseFloat(item.prediction?.rsi).toFixed(2)}</td>
                                <td>{parseFloat(item.prediction?.adx).toFixed(2)}</td> */}
                      <td style={{ textAlign: "right" }}>
                        {item.details.high52w
                          ? (
                              ((item.details.high52w - todayLTP?.LTP) * 100) /
                              item.details.high52w
                            ).toFixed(2)
                          : ""}
                        %
                      </td>
                      <td
                        title={`${moment(item.details.lowDate).format(
                          "DD-MM-YY"
                        )} / ${moment(item.details.highDate).format(
                          "DD-MM-YY"
                        )}`}
                      >
                        {item.details.low52w}
                        {item.details ? "/" : ""}
                        {item.details.high52w}
                      </td>

                      <td
                        style={{
                          backgroundColor:
                            parseInt(todayLTP?.VOLUME) >
                            parseInt(item.prediction?.ttl_trd_qty)
                              ? "#cde9d7"
                              : "",
                        }}
                        title={parseInt(
                          item.prediction?.ttl_trd_qty
                        )?.toLocaleString("en-IN")}
                      >
                        {parseInt(todayLTP?.VOLUME)?.toLocaleString("en-IN")}
                      </td>
                      {/* <td>{prevVolume}%</td> */}
                      <td
                        style={{
                          backgroundColor:
                            item.prediction?.delivery_spike ===
                              "Delivery Spike" && prevVolume > 100
                              ? "#cde9d7"
                              : "",
                        }}
                      >
                        {item.prediction?.delivery_per}%
                      </td>
                      <td>
                        <a
                          className="newsicon"
                          // href={`https://www.google.com/search?q=why+${symbolName}+high+volume+on+${moment(
                          //   item.breakout_date
                          // ).format("Do+MMMM+YYYY")}`}
                          href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                          target="_blank"
                        ></a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={13}></td>
                  <td
                    style={{
                      textAlign: "right",
                      fontWeight: "500",
                      color: totalPL > 0 ? "#0d7607" : "#f00",
                    }}
                  >
                    {totalPL.toFixed(2)}%
                  </td>
                  <td colSpan={8}></td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default GoldenStocksPage;
